import { CREATE_SCHOLARSHIP, CREATE_SCHOLARSHIP_ASSIGNMENT, CREATING_SCHOLARSHIP, CREATING_SCHOLARSHIP_ASSIGNMENT, DELETE_SCHOLARSHIP, DELETE_SCHOLARSHIP_ASSIGNMENT, DELETING_SCHOLARSHIP, DELETING_SCHOLARSHIP_ASSIGNMENT, GET_SCHOLARSHIP_ASSIGNMENTS, GET_SCHOLARSHIPS, GETTING_SCHOLARSHIP_ASSIGNMENTS, GETTING_SCHOLARSHIPS, SCHOLARSHIPS_ERROR, UPDATE_SCHOLARSHIP, UPDATE_SCHOLARSHIP_ASSIGNMENT, UPDATING_SCHOLARSHIP, UPDATING_SCHOLARSHIP_ASSIGNMENT } from "../types"


const initialState = {
    scholarships: [],
    loadingScholarships: true,
    scholarshipsError: null,
    creatingScholarship: false,
    createdScholarship: null,
    updatingScholarship: false,
    updatedScholarship: null,
    deletingScholarship: null,
    deletedScholarship : null,
    studentScholarships: [],
    loadingStudentScholarships: true,
    creatingStudentScholarship: false,
    createdStudentScholarship: null,
    updatingStudentScholarship: false,
    updatedStudentScholarship: null,
    deletingStudentScholarship: null,
    deletedStudentScholarship : null
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){

    switch(action.type){
        case GETTING_SCHOLARSHIPS:
        return {
            ...state,
            scholarships: [],
            loadingScholarships :action.payload,
        }
        case GET_SCHOLARSHIPS:
        return{
            ...state,
            loadingScholarships: false,
            scholarshipsError: null,
            scholarships: action.payload,
        }
        case CREATING_SCHOLARSHIP:
        return {
            ...state,
            creatingScholarship: action.payload,
        }
        case CREATE_SCHOLARSHIP:
        return{
            ...state,
            creatingScholarship: false,
            scholarshipsError: null,
            createdScholarship: action.payload,
        }
        case UPDATING_SCHOLARSHIP:
        return {
            ...state,
            updatingScholarship: action.payload,
        }
        case UPDATE_SCHOLARSHIP:
        return{
            ...state,
            loadingScholarships: false,
            updatingScholarship:false,
            scholarshipsError: null,
            updatedScholarship: action.payload,
        }
        case DELETING_SCHOLARSHIP:
        return {
            ...state,
            deletingScholarship: action.payload,
            // fetchingMembers:false
        }
        case DELETE_SCHOLARSHIP:
        return{
            ...state,
            deletingScholarship: null,
            scholarshipsError: false,
            deletedScholarship: action.payload,
        }
        case GETTING_SCHOLARSHIP_ASSIGNMENTS:
        return {
            ...state,
            loadingStudentScholarships :action.payload,
        }
        case GET_SCHOLARSHIP_ASSIGNMENTS:
        return{
            ...state,
            loadingStudentScholarships: false,
            scholarshipsError: null,
            studentScholarships: action.payload,
        }
        case CREATING_SCHOLARSHIP_ASSIGNMENT:
        return {
            ...state,
            creatingStudentScholarship: action.payload,
        }
        case CREATE_SCHOLARSHIP_ASSIGNMENT:
        return{
            ...state,
            creatingStudentScholarship: false,
            scholarshipsError: null,
            createdStudentScholarship: action.payload,
        }
        case UPDATING_SCHOLARSHIP_ASSIGNMENT:
        return {
            ...state,
            updatingStudentScholarship: action.payload,
        }
        case UPDATE_SCHOLARSHIP_ASSIGNMENT:
        return{
            ...state,
            loadingStudentScholarships: false,
            updatingStudentScholarship:false,
            scholarshipsError: null,
            updatedStudentScholarship: action.payload,
        }
        case DELETING_SCHOLARSHIP_ASSIGNMENT:
        return {
            ...state,
            deletingStudentScholarship: action.payload,
            // fetchingMembers:false
        }
        case DELETE_SCHOLARSHIP_ASSIGNMENT:
        return{
            ...state,
            deletingStudentScholarship: null,
            scholarshipsError: false,
            deletedStudentScholarship: action.payload,
        }
        case SCHOLARSHIPS_ERROR:
        return{
            ...state,
            loadingScholarships: false,
            updatingScholarship:false,
            creatingScholarship: false,
            creatingStudentScholarship: false,
            loadingStudentScholarships: false,
            scholarshipsError: action.payload 
        }
        default: return state
    }

}